module.exports = __webpack_public_path__ + "static/media/SIH-2019.7ee4cbe1.jpg";